export const TicketStatus = {
    PAYING: { id: 'PAYING', name: 'Pendiente de pago', color: 'warning' },
    PENDING: { id: 'PENDING', name: 'Pendiente de procesar', color: 'warning' },
    PROCESSED: { id: 'PROCESSED', name: 'Procesado', color: 'success' },
    EXPIRED: { id: 'EXPIRED', name: 'Caducado', color: 'error' },
    CANCELLED: { id: 'CANCELLED', name: 'Anulado', color: 'error' },
    // Futuro
    DELIVERING: { id: 'DELIVERING', name: 'En reparto', color: 'primary' },
    DELIVERED: { id: 'DELIVERED', name: 'Entregado', color: 'primary' }
}